import { Component, OnInit, ViewChild } from '@angular/core'
import { SideNavService } from './services/side-nav.service'
import { animate, state, style, transition, trigger } from '@angular/animations'
import { NavigationEnd, Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { AccountInfo, IsAccountService, IsBeAuthService } from '@interserve/angular'
import { appInitialize } from './views/localdata'
import { MasterService } from './services/master.service'
declare const window: { BeLoginCore: any; sessionStorage: Storage; top: any; parent: Window; location: Location }

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        trigger('navOpen', [
            state(
                'close',
                style({
                    paddingLeft: '0',
                })
            ),
            transition('close => *', [animate('0.2s')]),
            transition('* => close', [animate('0.2s')]),
        ]),
    ],
})
export class AppComponent implements OnInit {
    environmentKey: 'prod' | 'dev' = environment.environmentKey === 'prod' ? 'prod' : 'dev'

    navItems: any
    title = ''
    titleLink = ''
    subTitle = ''
    subTitleLink = ''
    subTitleColor = ''

    dispContent = false
    canDispContent = true
    navDisable = false
    token = ''
    account: AccountInfo | undefined = undefined
    constructor(
        private router: Router,
        private masterService: MasterService,
        private sideNavService: SideNavService,
        private isAccountService: IsAccountService,
        private isBeAuthService: IsBeAuthService
    ) {
        this.isAccountService.accountSource$.subscribe((account) => {
            this.isAccountService.selectedOrganizationId = account?.organizations[0]?.organizationId || ''
            this.account = this.isAccountService.account
            this.dispContent = true
        })
    }
    ngOnInit(): void {
        //サイドメニュー非表示切り替えの変更検知(Viewerはサイドメニュー非表示)
        this.sideNavService.navSource$.subscribe((ret) => {
            this.navDisable = this.sideNavService.NaveDisable
            this.subTitle = ''
            this.subTitleLink = ''
        })
        this.isAccountService.accountSource$.subscribe((account) => {
            this.isAccountService.selectedOrganizationId = account?.organizations[0]?.organizationId || ''
            if (!this.canDispContent) {
                return
            }
            // this.authService.setAccount(account) //ペタボ動作用
            this.dispContent = true
        })
        //★★暫定　メニューの取得部分省略してローカルデータ
        this.navItems = appInitialize.items.layout.menu
        this.masterService.setMenu(this.navItems)
        ;({
            title: this.title,
            titleLink: this.titleLink,
            subTitle: this.subTitle,
            subTitleLink: this.subTitleLink,
            subTitleColor: this.subTitleColor,
        } = appInitialize.items.layout.header)
    }
    // get navDisp(): boolean {
    //     return this.sideNavService.NavOpen
    // }
    logout() {
        // window.BeLoginCore.logout()
        // window.location.href =environment.myidea
        this.isBeAuthService.logout()
        location.reload()
    }
}
